// Barra laterale (redesign 2026-10, mockup "Home B2B goooled").
// - monitor: a sole icone (64px) o estesa (212px), scelta ricordata (la decide App.js)
// - laptop: a icone; ☰ la apre sopra il contenuto
// - telefono: nascosta; ☰ la apre come pannello
// Su laptop e telefono si chiude dopo la scelta di una voce.
import React, { useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiHome,
  FiEdit3,
  FiColumns,
  FiGitCommit,
  FiGrid,
  FiZap,
  FiPower,
  FiPackage,
  FiStar,
  FiTag,
  FiShoppingCart,
  FiClipboard,
  FiChevronsLeft,
  FiChevronsRight,
} from 'react-icons/fi';
import { CartContext } from '../context/CartContext';
import { useLanguage } from '../context/LanguageContext';
import '../css/Shell.css';

// Referente commerciale mostrato in fondo alla barra (prima era nell'intestazione)
const CONTACT = { name: 'Stefano Moro', email: 'stefano.moro@goooled.com', phone: '+39 3356059956', initials: 'SM' };

const Sidebar = ({ mode = 'desktop', expanded = false, overlayOpen = false, onNavigate, onToggleExpanded }) => {
  const { cart, loadCart } = useContext(CartContext);
  const { t } = useLanguage();
  const cartItemCount = cart.length;

  useEffect(() => {
    loadCart();
  }, [loadCart]);

  // Etichette visibili: barra estesa su monitor, oppure pannello aperto su laptop/telefono
  const showLabels = mode === 'desktop' ? expanded : overlayOpen;

  const groups = [
    { items: [{ to: '/dashboard', icon: FiHome, label: t('sidebar.home') }] },
    {
      title: t('sidebar.groupConfigure'),
      items: [
        { to: '/configurator', icon: FiEdit3, label: t('sidebar.customProfiles') },
        { to: '/looseprofiles', icon: FiColumns, label: t('sidebar.looseProfiles') },
        { to: '/btmconfigurator', icon: FiGitCommit, label: t('sidebar.btmSystem') },
      ],
    },
    {
      title: t('sidebar.groupProducts'),
      items: [
        { to: '/catalogo', icon: FiGrid, label: t('sidebar.catalog') },
        { to: '/StripLed', icon: FiZap, label: t('sidebar.stripLed') },
        { to: '/alimentatori', icon: FiPower, label: t('sidebar.powerSupplies') },
        { to: '/accessori', icon: FiPackage, label: t('sidebar.accessories') },
        { to: '/novita', icon: FiStar, label: t('sidebar.newArrivals') },
        { to: '/onsale', icon: FiTag, label: t('sidebar.onSale') },
      ],
    },
    {
      title: t('sidebar.groupWork'),
      items: [
        { to: '/cart', icon: FiShoppingCart, label: t('sidebar.cart'), count: cartItemCount },
        { to: '/orders', icon: FiClipboard, label: t('sidebar.orders') },
      ],
    },
  ];

  const handleNavigate = () => {
    if (typeof onNavigate === 'function') onNavigate();
  };

  return (
    <aside
      className={`sb sb-${mode}${showLabels ? ' sb-labels' : ' sb-icons'}${overlayOpen ? ' sb-open' : ''}`}
      aria-label={t('sidebar.menu')}
    >
      <nav className="sb-nav">
        {groups.map((group, gi) => (
          <div className="sb-group" key={gi}>
            {group.title && <div className="sb-group-title">{group.title}</div>}
            {group.items.map(({ to, icon: Icon, label, count }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) => `sb-item${isActive ? ' is-active' : ''}`}
                onClick={handleNavigate}
                title={showLabels ? undefined : label}
              >
                <Icon className="sb-icon" aria-hidden="true" />
                <span className="sb-label">{label}</span>
                {count > 0 && <span className="sb-count">{count}</span>}
                {count > 0 && <span className="sb-dot" aria-hidden="true" />}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="sb-contact" title={`${CONTACT.name} · ${CONTACT.phone}`}>
        <div className="sb-contact-avatar" aria-hidden="true">{CONTACT.initials}</div>
        <div className="sb-contact-text">
          <div className="sb-group-title">{t('sidebar.yourContact')}</div>
          <strong>{CONTACT.name}</strong>
          <span>{CONTACT.email}</span>
          <span>{CONTACT.phone}</span>
        </div>
      </div>

      {mode === 'desktop' && (
        <button
          type="button"
          className="sb-item sb-collapse"
          onClick={onToggleExpanded}
          title={expanded ? t('sidebar.collapse') : t('sidebar.expand')}
        >
          {expanded ? <FiChevronsLeft className="sb-icon" aria-hidden="true" /> : <FiChevronsRight className="sb-icon" aria-hidden="true" />}
          <span className="sb-label">{t('sidebar.collapse')}</span>
        </button>
      )}
    </aside>
  );
};

export default Sidebar;
